import { store } from "app/store";
let currentDrawingPolylines = [];

export const renderDrawing = (map, drawing_coordinates) => {
  const colors = store.getState().settings.colors;

  currentDrawingPolylines.map((currentDrawingPolylines, i) => {
    currentDrawingPolylines.setMap(null);
    return currentDrawingPolylines;
  });

  if (drawing_coordinates) {
    if (drawing_coordinates.length > 0) {
      let path = [];
      for (let i = 0; i < drawing_coordinates.length; i++) {
        let pathLatLong = {
          lat: drawing_coordinates[i].latitude,
          lng: drawing_coordinates[i].longitude
        };
        path.push(pathLatLong);
      }

      let drawnPolyline = new window.google.maps.Polyline({
        strokeColor: colors.success_color,
        strokeOpacity: 1,
        strokeWeight: 5,

        path: path //decodedPolyline.geometry.coordinates
      });
      drawnPolyline.setMap(map);
      currentDrawingPolylines.push(drawnPolyline);
    }
  }
};
